module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-outline', {
    attrs: {
      "title": _vm.changePassword_title,
      "iconFA": "gear"
    }
  }, [_c('template', {
    slot: "pageContent"
  }, [_c('b-row', {
    staticClass: "justify-content-start"
  }, [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.idtfr'),
      "inputValue": _vm.login
    }
  })], 1), _vm._v(" "), (!_vm.connectToGoogle) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "idLabel": _vm.$t('common.orig_pwd'),
      "placeholderValue": _vm.changePassword_OriginalPassword,
      "inputType": "password"
    },
    model: {
      value: (_vm.originalPassword),
      callback: function($$v) {
        _vm.originalPassword = $$v
      },
      expression: "originalPassword"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.connectToGoogle) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "idLabel": _vm.$t('common.pwd'),
      "placeholderValue": _vm.changePassword_Password,
      "inputType": "password"
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.connectToGoogle) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "idLabel": _vm.$t('common.new_pwd'),
      "placeholderValue": _vm.changePassword_NewPassword,
      "inputType": "password"
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "idLabel": _vm.$t('common.conf_pwd'),
      "placeholderValue": _vm.changePassword_ConfirmPassword,
      "inputType": "password"
    },
    model: {
      value: (_vm.confirmNewPassword),
      callback: function($$v) {
        _vm.confirmNewPassword = $$v
      },
      expression: "confirmNewPassword"
    }
  })], 1)], 1), _vm._v(" "), (_vm.connectToGoogle) ? _c('b-row', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "text-right col-sm-12 small font-italic"
  }, [_vm._v(_vm._s(_vm.$t('profilesPage.ggl_check_pwd')))])]) : _vm._e()], 1), _vm._v(" "), _c('template', {
    slot: "footerButtons"
  }, [_c('b-row', {
    staticClass: "form-group justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "md": "5",
      "xl": "3",
      "offset-xl": "7"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "title": _vm.changePassword_Validatechanges
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "icon fa fa-save"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.sve')))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-50326ae8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50326ae8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/CMChangePassword.vue
// module id = 2353
// module chunks = 2